import { render, staticRenderFns } from "./allfwlistitemnew.vue?vue&type=template&id=0f92cf1a&class=component&"
import script from "./allfwlistitemnew.vue?vue&type=script&lang=js&"
export * from "./allfwlistitemnew.vue?vue&type=script&lang=js&"
import style0 from "./allfwlistitemnew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f92cf1a')) {
      api.createRecord('0f92cf1a', component.options)
    } else {
      api.reload('0f92cf1a', component.options)
    }
    module.hot.accept("./allfwlistitemnew.vue?vue&type=template&id=0f92cf1a&class=component&", function () {
      api.rerender('0f92cf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/allfwlistitemnew.vue"
export default component.exports